import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { useI18n } from "../lib/LanguageContext";
import { useCart } from "../lib/CartContext";
import { formatIDR, localizeContent } from "../lib/translations";
import { ShoppingCart, Plus } from "lucide-react";

export default function ProductsPage() {
  const { t, lang } = useI18n(); const { add } = useCart();
  const [items, setItems] = useState([]); const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/products").then(r => setItems(r.data)); }, []);
  const filtered = cat === "all" ? items : items.filter(i => i.category === cat);
  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="products-page">
      <div className="text-xs tracking-[0.2em] uppercase font-bold text-teal mb-2">GIDZA</div>
      <h1 className="font-display text-4xl md:text-5xl font-medium mb-6">{t("products.title")}</h1>
      <div className="flex gap-2 mb-10">
        {[{k:"all",l:t("products.filter_all")},{k:"book",l:t("products.filter_book")},{k:"food",l:t("products.filter_food")}].map(f => (
          <button key={f.k} onClick={()=>setCat(f.k)} className={`pill text-sm border ${cat===f.k?"bg-teal text-white border-teal":"bg-white border-teal/20 text-foreground/80"}`} data-testid={`filter-${f.k}`}>{f.l}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map(p => (
          <Card key={p.id} className="overflow-hidden border-teal/10 rounded-2xl group" data-testid={`product-card-${p.id}`}>
            <div className="aspect-[4/3] overflow-hidden bg-teal-soft"><img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/></div>
            <div className="p-5">
              <div className="text-xs tracking-[0.18em] uppercase text-teal font-bold mb-1">{p.category === "book" ? t("products.filter_book") : t("products.filter_food")}</div>
              <h3 className="font-display text-lg leading-snug mb-1">{localizeContent(p.name, lang)}</h3>
              <p className="text-sm text-muted-foreground line-clamp-2">{localizeContent(p.description, lang)}</p>
              <div className="mt-4 flex items-center justify-between">
                <div className="font-display text-xl font-medium">{formatIDR(p.price)}</div>
                <Button size="sm" className="rounded-full bg-teal hover:bg-teal/90 text-white" onClick={()=>{ add(p); toast.success(`${localizeContent(p.name, lang)} → ${t("products.cart")}`); }} data-testid={`buy-btn-${p.id}`}>
                  <Plus className="w-3.5 h-3.5 mr-1"/> {t("products.buy")}
                </Button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
